import { IHasChildren } from '@/lib/interface';
import { cn } from '@/lib/utils.ts';
import { TAlign } from '.';

type TProps = IHasChildren & {
	align?: TAlign;
}

const UserProfileDetailsInfosItem = ({ children, align }: TProps) => (
	<div className={cn(
		'flex items-center text-muted-foreground space-x-1 text-sm',
		align === 'center' && 'justify-center',
		align === 'right' && 'justify-end'
	)}>
		{children}
	</div>
);

export default UserProfileDetailsInfosItem;
